import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_Microsoft",
  "use": "icon-icon_Microsoft-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon_Microsoft\"><path d=\"M0 0h486.613333v486.613333H0z\" fill=\"#F25022\" p-id=\"14183\" cursorshover=\"true\" /><path d=\"M537.386667 0H1024v486.613333H537.386667z\" fill=\"#7FBA00\" p-id=\"14184\" cursorshover=\"true\" /><path d=\"M0 537.344h486.613333v486.570667H0z\" fill=\"#00A4EF\" p-id=\"14185\" /><path d=\"M537.386667 537.344H1024v486.570667H537.386667z\" fill=\"#FFB900\" p-id=\"14186\" cursorshover=\"true\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_Microsoft.svg
// module id = Fe0l
// module chunks = 35